import clsx from "clsx";
import { memo, ReactElement, useMemo, useState } from "react";
import { MdCircle, MdInfo } from "react-icons/md";
import { forceIconSize } from "src/helpers/icon-utils";
import Button from "../Button/Button";
import { ICON_SIZES } from "src/constants/icons";

export enum EExtensionStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
}

export interface IExtensionInfo {
  name: string;
  description: string;
  icon: ReactElement;
  status: EExtensionStatus;
  isWorking: boolean;
  onInfoClick: () => void;
}

const ExtensionCard: React.FC<IExtensionInfo> = ({
  name,
  icon,
  status,
  isWorking,
  description,
  onInfoClick,
}) => {
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const finalStatus = useMemo(() => {
    if (status === EExtensionStatus.DISABLED) {
      return "Deshabilitado";
    }

    if (isWorking) {
      return "Habilitado";
    }

    return "Habilitado pero con problemas";
  }, [status, isWorking]);

  return (
    <>
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-3",
          "rounded",
          "bg-gray-50/60 dark:bg-gray-900/50",
          "p-3",
          "items-center",
          "cursor-pointer",
        ])}
        onClick={() => onInfoClick()}
      >
        <div className={clsx(["shrink-0"])}>
          {forceIconSize({ icon, size: ICON_SIZES.MD })}
        </div>
        <div className={clsx(["flex", "w-full", "flex-col"])}>
          <div className={clsx(["font-medium", "text-sm"])}>{name}</div>
          <div
            className={clsx([
              "flex",
              "gap-1",
              "flex-row",
              "w-full",
              "items-center",
            ])}
          >
            <MdCircle
              className={clsx([
                {
                  "text-green-400": isWorking,
                  "text-red-400": !isWorking,
                },
              ])}
              size={ICON_SIZES.XXS}
            />
            <div className={clsx(["text-xs", "md:text-xs"])}>{finalStatus}</div>
          </div>
        </div>
        <div className={clsx(["shrink-0"])}>
          <Button
            onClick={() => onInfoClick()}
            icon={<MdInfo size={ICON_SIZES.SM} />}
          />
        </div>
      </div>
    </>
  );
};

export default memo(ExtensionCard);
